import React from "react";
import { useLanguage } from "../LanguageContext";
import translations from "../translations";

const Experience = () => {

  const { language } = useLanguage();

  return (
    <section id="experience" className="px-6 py-12">
      {/* Título centralizado */}
      <div className="text-center mb-8">
        <h2 className="text-3xl font-extrabold text-gray-800">
          {translations[language].experience}
        </h2>
        <span className="block w-1/5 h-1 bg-blue-500 mx-auto mt-2"></span> {/* Largura reduzida para 1/5 */}
      </div>

      {/* Experiência atual */}
      <div className="bg-gradient-to-r from-blue-50 to-blue-50 shadow-lg rounded-lg p-6 mb-6 ">
        <h3 className="text-xl font-semibold text-gray-800">
        {translations[language].currentJob}
        </h3>
        <p className="text-lg text-gray-500 mt-1">{translations[language].jobPeriod}</p>

        <div className="mt-4">
          <p className="text-lg text-gray-700 leading-relaxed">
          {translations[language].experienceText1}
          </p>
          <ul className="mt-4 list-disc pl-6 text-gray-700">
            <li>{translations[language].experienceText2}</li>
            <li>{translations[language].experienceText3}</li>
            <li>{translations[language].experienceText4}</li>
            <li>{translations[language].experienceText5}</li>
            <li>{translations[language].experienceText6}</li>
            <li>{translations[language].experienceText7}</li>
            <li>{translations[language].experienceText8}</li>
            <li>{translations[language].experienceText9}</li>
          </ul>
        </div>
      </div>
    </section>
  );
};

export default Experience;
